<template>
  <!-- Left column -->
  <div v-if="isDataLoaded">
    <!-- Brochures chart -->
    <div class="full-width">
      <p class="card-title">{{ "Brochures" }}</p>
      <div class="card-block" :class="{'has-redirect':hasRedirect}" @click="redirect()">
        <line-chart
          v-show="dataReady"
          :chartData="data"
          :options="options"
          :height="200"
          :ref="component"
        />
        <!-- Legends -->
        <div
          v-for="(legend, index) in data.legends"
          :key="index"
          class="legend q-ml-md q-mt-md q-mb-sm"
          :class="{
            'text-hidden': data.datasets[index].hidden,
          }"
          @click="toggleData(index)"
        >
          <div :class="legend.color"></div>
          <span>{{ legend.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'brochures',
      data: {
        labels: [],
        datasets: [
          this.initDataset(this.getColor('blue')),
        ],
        legends: [{
          color: 'blue',
          label: 'Brochure',
        }],
      },
      options: {
        scales: this.scaleOptions,
        elements: {
          point: {
            radius: 2,
          },
        },
        legend: {
          display: false,
        },
      },
    };
  },
  methods: {
    handleData() {
      const stats = this.statisticData;
      this.data.datasets[0].data = stats.period.map(x => x.total * 1);
      this.data.labels = stats.period.map(x => this.formatDate(x.date, this.labelDateFormat));
      this.dataReady = true;
    },
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
